import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  type: {
    id: 'Type',
    defaultMessage: 'Type',
  },
});

export const projectGroupBlockSchema = (props) => {
  const { intl } = props;
  return {
    title: 'ProjectGroup Block',
    description: 'Display a group of persons involved in a project.',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['type', 'title'],
      },
    ],
    properties: {
      type: {
        title: intl.formatMessage(messages.type),
        description: 'The type of group (project or kommission).',
        widget: 'select',
        choices: [
          ['projectgroup', 'projectgroup'],
          ['kommission', 'kommission'],
        ],
        default: 'projectgroup',
      },
      title: {
        title: intl.formatMessage(messages.title),
        widget: 'textarea',
      },
    },
    required: [],
  };
};

export default projectGroupBlockSchema;
